import React from 'react';
import { Disc, Twitter, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-white/10 pt-16 pb-8" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-20">
          <div className="col-span-1 md:col-span-2" data-id="element-21">
            <div className="flex items-center gap-2 mb-6" data-id="element-22">
              <Disc className="w-8 h-8 text-neon-cyan" data-id="element-23" />
              <span className="text-2xl font-display font-black tracking-tighter text-white" data-id="element-24">
                LUTE<span className="text-neon-cyan" data-id="element-25">GAMES</span>
              </span>
            </div>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-26">
              Redefining the rhythm game genre with high-fidelity audio,
              beat-sync technology, and a community-first approach.
            </p>
            <div className="flex gap-4" data-id="element-27">
              <a href="#" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-gray-400 hover:bg-neon-cyan hover:text-black transition-all" data-id="element-28">
                <Twitter className="w-5 h-5" data-id="element-29" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-gray-400 hover:bg-neon-magenta hover:text-white transition-all" data-id="element-30">
                <Instagram className="w-5 h-5" data-id="element-31" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-gray-400 hover:bg-red-600 hover:text-white transition-all" data-id="element-32">
                <Youtube className="w-5 h-5" data-id="element-33" />
              </a>
            </div>
          </div>

          <div data-id="element-34">
            <h4 className="text-white font-bold mb-6 font-display" data-id="element-35">Explore</h4>
            <ul className="space-y-4" data-id="element-36">
              <li data-id="element-37">
                <a href="#problems" className="text-gray-400 hover:text-neon-cyan transition-colors" data-id="element-38">
                  The Silence
                </a>
              </li>
              <li data-id="element-39">
                <a href="#solutions" className="text-gray-400 hover:text-neon-cyan transition-colors" data-id="element-40">
                  The Rhythm
                </a>
              </li>
              <li data-id="element-41">
                <a href="#features" className="text-gray-400 hover:text-neon-cyan transition-colors" data-id="element-42">
                  Tracklist
                </a>
              </li>
              <li data-id="element-43">
                <a href="#pricing" className="text-gray-400 hover:text-neon-cyan transition-colors" data-id="element-44">
                  Backstage Pass
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-45">
            <h4 className="text-white font-bold mb-6 font-display" data-id="element-46">Studio</h4>
            <address className="text-gray-400 not-italic space-y-2" data-id="element-47">
              <p data-id="element-48">Lutegames HQ</p>
              <p data-id="element-49">Limassol, Cyprus</p>
              <p className="text-sm text-gray-600 mt-4" data-id="element-50">
                No phone support available.
              </p>
              <p className="text-sm text-gray-600" data-id="element-51">Digital inquiries only.</p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-52">
          <p className="text-gray-600 text-sm" data-id="element-53">
            © 2026 Lutegames. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-600" data-id="element-54">
            <a href="#" className="hover:text-white transition-colors" data-id="element-55">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-56">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}